import { getAuthAxiosBackend } from "../helpers/axios"

class AdminServices{

    get(id){
        return getAuthAxiosBackend().get('admins/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('admins', {params: data})
    }

    add(admin){
        return getAuthAxiosBackend().post('admins', admin)
    }

    edit(id, admin){
        return getAuthAxiosBackend().put('admins/'+id, admin)
    }

    delete(id){
        return getAuthAxiosBackend().delete('admins/'+id)
    }

    resetPassword(id, data){
        return getAuthAxiosBackend().put('admin/password/reset/'+id, data)
    }
}

export default new AdminServices()